import classnames from 'classnames'
import { isNil } from 'ramda'
import React from 'react'

import { iconEvidenceShadowed } from 'modules/ui/assets'
import { toPercent } from 'modules/util'
import Part from '../../Part'
import DraggablePart from '../DraggablePart'
import DropContainer from '../DropContainer'
import enhance from './enhancers'

export function Parts(props) {
  const {
    active,
    handleActivate,
    handleClickAway,
    handleInput,
    order,
    parts,
    ready,
    theme
  } = props

  return (
    <div className={classnames({ [theme.ready]: ready })}>
      {!isNil(active) &&
        <div className={theme.overlay} onClick={handleClickAway} />
      }

      <DropContainer>
        {parts.map((part, index) => {
          const position = {
            top: toPercent(part.y),
            left: toPercent(part.x),
            zIndex: order.indexOf(index) + 20
          }
          const iconClass = classnames(theme.icon, {
            [theme.first]: index === 0
          })

          return (
            <DraggablePart
                id={index}
                key={index}
                position={position}
                onActivate={handleActivate(index)}
                onBeginDrag={handleActivate(null)}>
              {part.dirty
                ? <Part
                    editable
                    active={active === index}
                    part={part}
                    onActivate={handleActivate(index)}
                    onInput={handleInput(index)} />
                : <img
                    alt='evidence'
                    className={iconClass}
                    src={iconEvidenceShadowed} />
              }
            </DraggablePart>
          )
        })}
      </DropContainer>
    </div>
  )
}

export default enhance(Parts)



// WEBPACK FOOTER //
// ./client/modules/debate/components/Builder/Parts/index.js